import { prismicService } from '@services/businessContainer';
import { useEffect, useState } from 'react';
import { PrismicDocument } from '@prismicio/client';
import { PrismicLink } from '@monofront/design-system/prismic-link/PrismicLink';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { useMediaQuery } from '@monofront/business/hooks';
import { PrismicLinkContext } from '@monofront/types';

interface IImageBannerProps {
  prismicUid: string;
}

export const ImageBanner: React.FC<IImageBannerProps> = ({ prismicUid }) => {
  const [bannerDocument, setBannerDocument] = useState<null | PrismicDocument>(
    null,
  );
  const isMobile = useMediaQuery(800);

  useEffect(() => {
    (async () => {
      const banner = await prismicService.getDocumentByUid(
        'algoliacollectionimagebanner',
        prismicUid,
      );

      setBannerDocument(banner);
    })();
  }, [prismicUid]);

  if (!bannerDocument) {
    return null;
  }

  const banner = isMobile
    ? bannerDocument.data.mobile_banner
    : bannerDocument.data.web_banner;

  if (!banner) {
    return null;
  }

  return (
    <div className="tw-mb-2">
      <PrismicLink
        link={bannerDocument.data.link}
        context={PrismicLinkContext.SHOP}
      >
        <ResponsiveImage
          width={banner.dimensions?.width}
          height={banner.dimensions?.height}
          src={banner?.url}
          alt={banner?.alt}
          raw
          className="tw-h-auto tw-w-full tw-rounded-lg tw-object-cover tw-rendering-sharp md:tw-h-[120px] md:tw-w-auto"
        />
      </PrismicLink>
    </div>
  );
};
